import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {TalentHappyPathAuthService} from "./talent-happy-path-auth.service";
import {TalentHappyPathAuthApiService} from "./talent-happy-path-auth-api.service";


@Injectable({
  providedIn: 'root'
})
export class TalentHappyPathTokenInterceptorService implements HttpInterceptor {

  tokenRefreshing: boolean = false;

  constructor(private authService: TalentHappyPathAuthService,
              private api: TalentHappyPathAuthApiService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.authService.authentication && this.authService.authentication.id_token ) {
      const req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.authentication.id_token}`
        }
      });
      return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!this.tokenRefreshing) {
            this.tokenRefreshing = true;
            this.api.refreshToken().subscribe(() => {
              this.tokenRefreshing = false;
            });
          }
        }
      }));
    } else {
      return next.handle(request);
    }
  }
}
